import React from 'react';
import { useLocation } from 'react-router-dom';

const MarketingHeader = () => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/marketing/email/templates')) return 'Email Templates';
    if (path.includes('/marketing/email/workflows')) return 'Email Workflows';
    if (path.includes('/marketing/email/send')) return 'Quick Send';
    if (path.includes('/marketing/email/logs')) return 'Email Logs';
    if (path.includes('/marketing/forms/new')) return 'New Form';
    if (path.includes('/marketing/forms') && path.includes('/edit')) return 'Form Editor';
    if (path.includes('/marketing/forms') && path.includes('/responses')) return 'Form Responses';
    if (path.includes('/marketing/forms') && path.includes('/share')) return 'Share Form';
    if (path.includes('/marketing/forms')) return 'Marketing Forms';
    if (path.startsWith('/marketing')) return 'Marketing Dashboard';
    return 'Marketing';
  };

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-4 sticky top-0 z-30 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
          {getPageTitle()}
        </h2>
      </div>
    </header>
  );
};

export default MarketingHeader;
